export const landingNavigation = Object.freeze([
    {
        id: "solutions",
        labelKey: "main.header.landingNavigation.solutions",
    },
    {
        id: "tariffs",
        labelKey: "main.header.landingNavigation.tariffs",
    },
    {
        id: "start",
        labelKey: "main.header.landingNavigation.start",
    },
    {
        id: "faq",
        labelKey: "main.header.landingNavigation.faq",
    },
]);